// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__1ykF7","obliqueLineWrap":"membershipbadge_obliqueLineWrap__1hHMn","obliqueLine":"membershipbadge_obliqueLine__2Yxjc"};